import React from "react";
import { Translation } from "react-i18next";
import { NO_DATA_FOUND_MESSAGE } from "../../utilities/Constants";


interface INoDataFoundProps {
  moduleName: string;
  message?: string;
}

export default class NoDataFound extends React.Component<INoDataFoundProps, {}> {
  private _mount: boolean = false;

  constructor(props: INoDataFoundProps) {
    super(props);
    this._mount = true;

  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
  }

  public render() {

    return (
      <React.Fragment>

        {this.props.message ?
          <Translation>
            {
              t =>
                <div className="no-data-found-message p-2">
                  <div className="no-data-box-message mx-4 rounded">
                    <div className="no-data-text text-center p-4">
                      <p className="font-weight-bold">{t(this.props.message)}</p>
                    </div>
                  </div>
                </div>
            }
          </Translation>
          :
          <Translation>
            {
              t =>
                <div className="no-data-found p-2 mr-4">
                  <div className="no-data-box mx-4 rounded">
                    <div className="no-data-text text-center p-4">
                      <p className="font-weight-bold">{this.props.moduleName} {t(NO_DATA_FOUND_MESSAGE)}.</p>
                    </div>
                  </div>
                </div>
            }
          </Translation>
        }

      </React.Fragment>
    );
  }
}
